import styled from 'styled-components';

export const InputForm = styled.div`
  background-color: ${(props) => props.background};
  padding: 16px;

  & input {
    outline: none;
    border: none;
    background: ${(props) => (props.desktopform ? '#f4f4f5' : '#fff')};
    width: 100%;
    padding: 14px 16px;
    margin: 10px 0;
    border-radius: 4px;
    font-family: 'Montserrat';

    &::placeholder {
      color: hsl(0deg, 0%, 0%, 40%);
      font-weight: 500;
      font-size: 15px;
    }
  }
`;

export const FormTitle = styled.h3`
  color: hsl(0deg, 0%, 0%, 61%);
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  text-decoration: underline;
  text-underline-offset: 16px;
  text-decoration-color: ${(props) =>
    props.whymylo ? '#e2c7fc59' : '#f9f4fe75'};
  padding: 16px 0 20px;
`;

export const Appointmentbtn = styled.button`
  border: ${(props) => (props.white ? '1px solid #ef4e5e' : 'none')};
  outline: none;
  width: 100%;
  height: 44px;
  line-height: 44px;
  background-color: ${(props) => (props.white ? '#fff' : '#ef4e5e')};
  color: ${(props) => (props.white ? '#ef4e5e' : '#fff')};
  font-weight: 500;
  border-radius: ${(props) => (props.round ? '24px' : '4px')};
  text-align: center;
  text-transform: uppercase;
  font-size: 15px;
  box-shadow: ${(props) =>
    props.white ? 'none' : '0 2px 4px 0 rgba(0, 0, 0, 0.16)'};
  margin: 14px 0 4px;
  cursor: pointer;
`;
export const ImmediateAssist = styled.p`
  font-size: 12px;
  color: #00000061;
  padding: ${(props) => props.padd};
`;
export const IVFMainContainer = styled.div`
  width: 100%;
  max-width: 1060px;
  margin: 0 auto;
  padding-top: 110px;
`;
export const Loader = styled.div`
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #ef4e5e;
  width: 30px;
  height: 30px;
  margin: auto;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
